// extracted by mini-css-extract-plugin
export default {"email":"Email_email__n0AJy","inputButton":"Email_inputButton__VLXPf"};